module.exports = __webpack_public_path__ + "static/media/user-profile.1e976c46.png";